<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col text-center">
        <h5>HomApt Reward: ${{reward}}</h5>
        <router-link to="/rebates">
          <p class="no-bottom-margin">Estimated Savings with a HomApt Agent*</p>
        </router-link>
        <button class="btn btn-primary question-button" v-on:click="showQuestionModal">Ask a Question</button>
      </div>
      <b-modal id="questionModal" ref="questionModal" size="lg" hide-footer class="homapt-question-modal">
        <div slot="modal-header" class="w-100 justify-content-center">
          <button v-on:click="hideQuestionModal" class="close d-inline" type="button" aria-label="Close">x</button>
          <div class="row">
            <div class="col text-center">
              <h3 class="m-0">Ask A Question</h3>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row form-row">
            <div class="col-md-3 text-right my-auto">
              <p class="mb-0">Name<span class="red-text" v-if="!name">*</span></p>
            </div>
            <div class="col-md-9 my-auto">
              <input v-model="name"
                class="form-control form-control-md"
                placeholder="Enter your name"
                v-bind:class="{'is-invalid': nameInvalid}">
              <div class="invalid-feedback">
                Please enter a name
              </div>
            </div>
          </div>
          <div class="row form-row">
            <div class="col-md-3 text-right my-auto">
              <p class="mb-0">Email<span class="red-text" v-if="!email">*</span></p>
            </div>
            <div class="col-md-9 my-auto">
              <input v-model="email"
                class="form-control form-control-md"
                placeholder="Enter an email"
                v-bind:class="{'is-invalid': emailInvalid}">
              <div class="invalid-feedback">
                Please enter a valid email address
              </div>
            </div>
          </div>
          <div class="row form-row">
            <div class="col-md-3 text-right my-auto">
              <p class="mb-0">Question<span class="red-text" v-if="!question">*</span></p>
            </div>
            <div class="col-md-9">
              <textarea v-model="question"
                class="form-control form-control-md"
                placeholder="Let us know any additional information"
                v-bind:class="{'is-invalid': questionInvalid}"
                rows="4"></textarea>
              <div class="invalid-feedback">
                Please enter a question
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4 offset-2">
              <button type="button" class="btn btn-secondary" v-on:click="hideQuestionModal">Cancel</button>
            </div>
            <div class="col-4">
              <button type="button" class="btn btn-primary" v-on:click="submitQuestion">Send</button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    price: Number
  },
  data () {
    return {
      name: null,
      nameInvalid: false,
      email: null,
      emailInvalid: false,
      question: null,
      questionInvalid: false,
      formInvalid: false
    }
  },
  computed: {
    reward () {
      if (this.price < 100000) return 100
      if (this.price <= 250000) return Math.round((this.price * 0.025) * 0.1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      if (this.price <= 500000) return Math.round((this.price * 0.025) * 0.15).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      if (this.price >= 500000) return Math.round((this.price * 0.025) * 0.2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  methods: {
    showQuestionModal () {
      this.$refs.questionModal.show()
    },
    hideQuestionModal () {
      this.$refs.questionModal.hide()
    },
    validate () {
      this.formInvalid = false

      var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!emailRegex.test(this.email)) {
        this.emailInvalid = true
        this.formInvalid = true
      } else {
        this.emailInvalid = false
      }

      if (!this.name) {
        this.nameInvalid = true
        this.formInvalid = true
      } else {
        this.nameInvalid = false
      }

      if (!this.question) {
        this.questionInvalid = true
        this.formInvalid = true
      } else {
        this.questionInvalid = false
      }
    },
    async submitQuestion () {
      this.validate()
      if (this.formInvalid) return
      var client = this.$store.getters.getEmailApigClientFactory
      var params = {}
      var pathTemplate = '/question'
      var method = 'POST'
      var additionalParams = {}
      var body = {
        email: this.email,
        name: this.name,
        question: this.question
      }
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.hideQuestionModal()
        this.$bvToast.show('my-toast')
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
.form-row {
  margin-bottom: 1rem;
}

.btn {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/rightSide/Question.vue